// NAP-Single-Source (Name/Adresse/Telefon) + Schema.org-Builder für die
// Notfall-Seiten. Der vollständige Dentist-Node steht genau EINMAL auf dem Hub;
// alle Spokes referenzieren nur per @id (dentistRef) — keine NAP-Kopien.

export const CLINIC = {
  name: 'SeaDent Mallorca',
  url: 'https://seadent.es',
  dentistId: 'https://seadent.es/#dentist',
  phone: '+34603319648',
  phoneDisplay: '603 31 96 48',
  whatsapp: 'https://wa.me/34603319648',
  streetAddress: 'Avenida de Jaime III, 3',
  postalCode: '07012',
  city: 'Palma de Mallorca',
  region: 'Illes Balears',
  country: 'ES',
  languages: ['de', 'en', 'es'],
  reviewer: {
    name: 'Jan David Heiringhoff',
    credential: 'Col·legiat Nº 07001232 — Col·legi Oficial de Dentistes de Balears',
    reviewedDate: '2026-07-01',
  },
};

/**
 * Vollständiger Dentist-Node (nur auf dem Hub rendern). Praxiszeiten Mo–Fr
 * 09–18 bewusst getrennt vom 24/7-Notfall-TELEFON (contactPoint) — die Praxis
 * ist NICHT 24/7 geöffnet.
 */
export function dentistNode(): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'Dentist',
    '@id': CLINIC.dentistId,
    name: CLINIC.name,
    url: CLINIC.url,
    telephone: CLINIC.phone,
    address: {
      '@type': 'PostalAddress',
      streetAddress: CLINIC.streetAddress,
      addressLocality: CLINIC.city,
      addressRegion: CLINIC.region,
      postalCode: CLINIC.postalCode,
      addressCountry: CLINIC.country,
    },
    // TODO(Betreiber): Geo-Koordinaten mit Google Business Profile abgleichen.
    geo: {
      '@type': 'GeoCoordinates',
      latitude: 39.5718,
      longitude: 2.6444,
    },
    openingHoursSpecification: [
      {
        '@type': 'OpeningHoursSpecification',
        dayOfWeek: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
        opens: '09:00',
        closes: '18:00',
      },
    ],
    contactPoint: [
      {
        '@type': 'ContactPoint',
        contactType: 'emergency',
        telephone: CLINIC.phone,
        availableLanguage: CLINIC.languages,
        hoursAvailable: {
          '@type': 'OpeningHoursSpecification',
          dayOfWeek: [
            'Monday',
            'Tuesday',
            'Wednesday',
            'Thursday',
            'Friday',
            'Saturday',
            'Sunday',
          ],
          opens: '00:00',
          closes: '23:59',
        },
      },
    ],
    availableLanguage: CLINIC.languages,
  };
}

/** Referenz auf den Hub-Dentist-Node — für alle Spokes statt NAP-Kopie. */
export function dentistRef(): object {
  return { '@id': CLINIC.dentistId };
}

export function breadcrumbLd(items: { name: string; url: string }[]): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, i) => ({
      '@type': 'ListItem',
      position: i + 1,
      name: item.name,
      item: item.url,
    })),
  };
}

export function faqLd(items: { q: string; a: string }[]): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'FAQPage',
    mainEntity: items.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: { '@type': 'Answer', text: item.a },
    })),
  };
}

/**
 * MedicalWebPage pro Spoke: about = MedicalCondition, lastReviewed/reviewedBy
 * aus CLINIC.reviewer. Colegiado-Nr. als PropertyValue-identifier (nicht im
 * description-Feld). Bewusst KEIN AggregateRating und KEIN HowTo (Spam-Risiko
 * bzw. deprecated).
 */
export function medicalWebPageLd(p: {
  name: string;
  description: string;
  url: string;
  about: string;
  lang: string;
}): object {
  return {
    '@context': 'https://schema.org',
    '@type': 'MedicalWebPage',
    name: p.name,
    description: p.description,
    url: p.url,
    inLanguage: p.lang,
    about: { '@type': 'MedicalCondition', name: p.about },
    lastReviewed: CLINIC.reviewer.reviewedDate,
    reviewedBy: {
      '@type': 'Person',
      name: CLINIC.reviewer.name,
      jobTitle: 'Odontòleg',
      identifier: {
        '@type': 'PropertyValue',
        propertyID: 'Col·legi Oficial de Dentistes de Balears',
        value: CLINIC.reviewer.credential,
      },
    },
  };
}
